// 字段字典（字段级权限资源，方案A：前端常量维护）
// 每个列表登记其所有字段，code 用于字段权限；required=true 为必显字段，不可被隐藏
// hidden_fields 采用「黑名单」语义：默认全选（隐藏集为空），新增字段默认可见

const FIELD_RESOURCE = [
    {
        code: 'serial:list',
        label: '串码池',
        fields: [
            { code: 'mac', label: 'MAC', required: true },
            { code: 'platform', label: '运营平台' },
            { code: 'fields', label: '平台字段', dynamic: true },
            { code: 'sn', label: 'SN', required: true },
            { code: 'key', label: '密钥' },
            { code: 'order_no', label: '工单号' },
            { code: 'factory', label: '生产工厂' },
            { code: 'model', label: '设备型号' },
            { code: 'auth_status', label: '授权状态', required: true },
            { code: 'bind_status', label: '绑定状态', required: true },
            { code: 'logistics_status', label: '物流状态', required: true },
            { code: 'issue_time', label: '下发时间' },
            { code: 'cpu_id', label: 'CPUID' },
            { code: 'bind_time', label: 'CPUID绑定时间' },
            { code: 'import_time', label: '导入时间' },
        ],
    },
    {
        code: 'order:list',
        label: '工单管理',
        fields: [
            { code: 'order_no', label: '工单号', required: true },
            { code: 'purpose', label: '串码用途' },
            { code: 'factory', label: '生产工厂' },
            { code: 'platform', label: '运营平台' },
            { code: 'model', label: '设备型号' },
            { code: 'status', label: '工单状态', required: true },
            { code: 'allocated', label: '已分配/需求产量' },
            { code: 'produced', label: '已生产' },
            { code: 'remark', label: '备注' },
            { code: 'creator', label: '创建人' },
            { code: 'create_time', label: '创建时间' },
        ],
    },
    {
        code: 'serial:import-records',
        label: '导入记录',
        fields: [
            { code: 'file_name', label: '文件名', required: true },
            { code: 'platform', label: '平台' },
            { code: 'operator', label: '操作人' },
            { code: 'import_time', label: '导入时间' },
            { code: 'total', label: '导入数量' },
            { code: 'success', label: '成功' },
            { code: 'fail', label: '失败' },
        ],
    },
    {
        code: 'serial:void-records',
        label: '作废记录',
        fields: [
            { code: 'mac', label: 'MAC', required: true },
            { code: 'void_type', label: '作废类型' },
            { code: 'platform', label: '平台' },
            { code: 'fields', label: '平台字段', dynamic: true },
            { code: 'sn', label: 'SN' },
            { code: 'void_time', label: '作废时间' },
        ],
    },
    {
        code: 'serial:unbind-records',
        label: '解绑记录',
        fields: [
            { code: 'sn', label: 'SN', required: true },
            { code: 'mac', label: 'MAC', required: true },
            { code: 'cpu_id', label: 'CPUID' },
            { code: 'uid', label: 'UID' },
            { code: 'fields', label: '平台字段', dynamic: true },
            { code: 'order_no', label: '工单号' },
            { code: 'purpose', label: '串码用途' },
            { code: 'factory', label: '生产工厂' },
            { code: 'model', label: '设备型号' },
            { code: 'unbind_time', label: '解绑时间' },
            { code: 'operator', label: '操作人' },
        ],
    },
    {
        code: 'serial:reset-records',
        label: '重置记录',
        fields: [
            { code: 'sn', label: 'SN', required: true },
            { code: 'mac', label: 'MAC' },
            { code: 'fields', label: '平台字段', dynamic: true },
            { code: 'before_status', label: '重置前授权状态' },
            { code: 'order_no', label: '工单号' },
            { code: 'purpose', label: '串码用途' },
            { code: 'factory', label: '生产工厂' },
            { code: 'model', label: '设备型号' },
            { code: 'reset_time', label: '重置时间' },
            { code: 'operator', label: '操作人' },
        ],
    },
    {
        code: 'serial:shipment-records',
        label: '发货报盘',
        fields: [
            { code: 'file_name', label: '文件名', required: true },
            { code: 'operator', label: '操作人' },
            { code: 'time', label: '报盘时间' },
            { code: 'total', label: '总数' },
            { code: 'success', label: '成功' },
            { code: 'fail', label: '失败' },
        ],
    },
    {
        code: 'serial:return-records',
        label: '退货管理',
        fields: [
            { code: 'file_name', label: '文件名', required: true },
            { code: 'operator', label: '操作人' },
            { code: 'time', label: '退货时间' },
            { code: 'total', label: '总数' },
            { code: 'success', label: '成功' },
            { code: 'fail', label: '失败' },
        ],
    },
    {
        code: 'auth:alerts',
        label: '异常告警',
        fields: [
            { code: 'type', label: '告警类型', required: true },
            { code: 'mac', label: 'MAC' },
            { code: 'sn', label: 'SN' },
            { code: 'order_no', label: '工单号' },
            { code: 'cpu_id', label: 'CPUID' },
            { code: 'email', label: '收件邮箱' },
            { code: 'time', label: '告警时间' },
            { code: 'status', label: '发送状态' },
        ],
    },
];

// 列表 code -> 字段数组
export const getFieldMap = () => {
    const map = {};
    FIELD_RESOURCE.forEach((r) => { map[r.code] = r.fields; });
    return map;
};

// 列表 code -> 全部字段 code 数组（用于「全选」默认值）
export const getAllFieldCodes = () => {
    const map = {};
    FIELD_RESOURCE.forEach((r) => { map[r.code] = r.fields.map((f) => f.code); });
    return map;
};

export default FIELD_RESOURCE;
